<template>
  <ModalDialog
    ref="dialog"
    title="Edit Account"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-server"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Company Name"><FormInputText placeholder="Company Name" v-model="account.companyName" field="companyName" /></FormRow>
      <FormRow label="Display Name"><FormInputText placeholder="Display Name" v-model="account.displayName" field="displayName" note="Used for displaying in web system" /></FormRow>
      <FormRow label="Company ACN"><FormInputText placeholder="Company ACN" v-model="account.companyACN" field="companyACN" /></FormRow>
      <FormRow label="Company ABN"><FormInputText placeholder="Company ABN" v-model="account.companyABN" field="companyABN" /></FormRow>
      <FormRow label="Currency Code">
        <FormInputText placeholder="Code" v-model="account.currencyCode" field="currencyCode" />
      </FormRow>
      <FormRow label="Sales Tax Rate">
        <FormSelect v-model="account.salesTaxRateId" :optionsPromise="taxRateOptionsPromise" field="salesTaxRateId" />
      </FormRow>
      <FormHorizontalRule />
      <FormRow label="Timezone Code">
        <FormSearchableSelect :options="timezoneCodeList" placeholder="Timezone" v-model="account.timezoneCode" field="timezoneCode" />
      </FormRow>
      <FormRow label="Country Code">
        <FormSelect v-model="account.countryCode" :options="countryCodeLookup" field="countryCode" />
      </FormRow>
      <FormRow label="State Code">
        <FormSelect v-model="account.stateCode" :options="stateCodeLookup" field="stateCode" />
      </FormRow>
      <FormHorizontalRule />
      <FormRow label="Email - Reply To Address"><FormInputText placeholder="Reply To" v-model="account.emailReplyToAddress" field="emailReplyToAddress" /></FormRow>
      <FormRow label="Email - From Name"><FormInputText placeholder="From Name" v-model="account.emailFromName" field="emailFromName" /></FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "AccountEditDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
  },
  data() {
    return {
      account: {},
      dialogForm: {},
      submitting: false, 
      timezoneCodeList: [],

      taxRateOptionsPromise: this.getTaxRateOptionsPromise(),

      // Fixed just to Australia states for now
      countryCodeLookup: [
        { value: 'AU', name: 'Australia' },
      ],
      stateCodeLookup: [
        { value: 'ACT', name: 'Australian Capital Territory' },
        { value: 'NSW', name: 'New South Wales' },
        { value: 'NT', name: 'Northern Territory' },
        { value: 'QLD', name: 'Queensland' },
        { value: 'SA', name: 'South Australia' },
        { value: 'TAS', name: 'Tasmania' },
        { value: 'VIC', name: 'Victoria' },
        { value: 'WA', name: 'Western Australia' }
      ]
    }
  },
  mounted() {
    this.timezoneCodeList = moment.tz.names().map(tz => { return { name: tz, value: tz } })    
  },
  computed: {
  },
  methods: {
    show(account) {
      // Reset form
      this.account = { }
      this.dialogForm = {}
      this.submitting = false
    
      if(account != null) {
        this.account = _.cloneDeep(account)
      }

      // Autodetect the timezone
      if(this.account.timezoneCode == null || this.account.timezoneCode == '')
        this.account.timezoneCode = moment.tz.guess()

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.account)

      this.$apiService.adminService.updateAccount(updateData)
      .then(() => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.dialogForm = this.processFormResponse(err)
      })
    },

    getTaxRateOptionsPromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.adminService.getTaxRateList()
        .then(response => {
          var taxRateOptions = response.data.map(taxRate => {
            return { value: taxRate.id, name: taxRate.displayName }
          })
          resolve(_.concat({ value: null, name: 'None' }, taxRateOptions))
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>